export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const UPDATE_ROLE_PERMISSION_SUCCESS = 'UPDATE_ROLE_PERMISSION_SUCCESS';
export const ADD_ROLE_SUCCESS = 'ADD_ROLE_SUCCESS';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_PERMISSION_SUCCESS = 'DELETE_ROLE_PERMISSION_SUCCESS';
